<template>
  <div class="whats-new-wrapper">
    <p class="p-whats-new">what's new</p>
    <ul>
      <li v-for="news in newsList" :key="news.news_id">
        <a :href="news.link">{{ news.date }} &nbsp; | &nbsp; {{ news.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    limit: {
      type: Number,
      default: 3, // デフォルトの取得件数
    },
  },
  data() {
    return {
      newsList: [], // 取得したニュースのリスト
    };
  },
  methods: {
    // APIからデータを取得する関数
    async fetchWhatsNew() {
      try {
        const API_ENDPOINT =
          "https://ueogztpyj9.execute-api.ap-northeast-1.amazonaws.com/prod/FetchWhatsNew";

        const response = await axios.get(API_ENDPOINT, {
          params: { limit: this.limit }, // パラメータにlimitを追加
        });

        this.newsList = response.data;
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    },
  },
  mounted() {
    this.fetchWhatsNew(); // コンポーネントがマウントされたときにデータを取得
  },
};
</script>

<style scoped>
.whats-new-wrapper {
  height: 200px;
  width: 450px;
  background-color: #FFFFFF;
  z-index: 3;
}
.p-whats-new {
  position: relative;
  top: 25px;
  left: 40px;
  color: #000000;
  font-size: 15px;
  font-weight: 500;
  font-family: sans-serif;
}
.whats-new-wrapper ul {
  position: relative;
  top: 45px;
  left: 0px;
  list-style: none;
}
.whats-new-wrapper li {
  list-style: none;
  padding-bottom: 15px;
}
.whats-new-wrapper a {
  text-decoration: none; 
  writing-mode:horizontal-tb;
  color: #000000;
  font-size: 12px;
  font-family: sans-serif;
  width: 380px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 表示行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}
.whats-new-wrapper a:hover{
  -webkit-line-clamp: 2; /* 表示行数 */
  overflow: visible;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .whats-new-wrapper {
      bottom: -60px;
      right: unset;
      left: 0;
      height: 70px;
      width: 95vw;
    }

    .p-whats-new {
      top: 30px;
      left: 0px;
      font-size: 11px;
    }

    .whats-new-wrapper ul {
      top: 50px;
      left: 0px;
      padding-inline-start: 0%;
    }

    .whats-new-wrapper a {
      font-size: 10px;
      width: 100%;
    }
  }
  @media screen and (max-width: 570px) {
    .whats-new-wrapper {
      bottom: -50px;
      right: unset;
      left: 0;
      height: 70px;
      width: 95vw;
    }

    .p-whats-new {
      top: 0px;
      left: 0px;
      font-size: 11px;
      padding-left: 3.5%;
    }

    .whats-new-wrapper ul {
      top: 10px;
      left: 0px;
      padding-inline-start: 0%;
    }

    .whats-new-wrapper a {
      font-size: 10px;
      width: 100%;
      padding-left: 4%;
    }
  }
</style>